import React from 'react';
import { IMenuItemResponce } from '../../../../../../Interfaces/responseTypes';
import { IMenuItemActions, MenuListTypes } from '../../../../../../Interfaces/componentTypes';
import { useGeneralHooks } from '../../../../../../Hooks/hooks';
import useDragnDropHooks from '../../../../../../Hooks/dragndrop-hook';
import { Drag, View } from '../../../../../../Assets/Icons';
import styles from './itemcard.module.scss';

export interface IProps {
    data: IMenuItemResponce;
    title: string;
    onClick?: () => void;
    type: MenuListTypes;
    order_list?: number[];
    categoryId: number,
    actions?: IMenuItemActions[] | [];
    onOrderChange?: (updatedOrder: number[]) => void;
    handleItemIsActive?: (categoryId: number, data: IMenuItemResponce) => void
}

const ItemCard: React.FC<IProps> = (props) => {
    const {
        data,
        onClick = () => { },
        type,
        actions = [],
        title,
        order_list,
        onOrderChange,
        categoryId,
        handleItemIsActive
    } = props;
    const { baseURL, mobileScreen } = useGeneralHooks();
    const { cardRef, isDragging, isDraggable, handleDrag, dragEndHandler, dropHandler, dragOverHandler, dragStartHandler, handleIconMouseDown, handleIconMouseUp } = useDragnDropHooks(order_list!, onOrderChange!)

    return (
        <div
            ref={cardRef}
            id={String(data.id)}
            className={`${styles.cardBox} ${isDragging ? styles.dragging : ''}`}
            draggable={isDraggable && type === MenuListTypes.EDIT}
            onClick={onClick}
            onDragStart={(e) => dragStartHandler(e, data)}
            onDragEnd={dragEndHandler}
            onDragOver={dragOverHandler}
            onDrop={order_list ? (e) => dropHandler(e, data.id) : undefined}
            onDrag={handleDrag}
        >
            <div
                className={type === MenuListTypes.EDIT ? styles.cardEdit : styles.cardView}
                onClick={onClick}
            >
                <div
                    className={`${styles.cardImage} ${!data.is_active && styles.cardImageDisabled}`}
                    style={{ backgroundImage: `url(${baseURL}${data.image})` }}
                >
                    <div className={styles.cardTitle}>
                        <p>{title.length > 15 ? title.slice(0, 15) + "..." : title}</p>
                    </div>
                </div>
            </div>
            {type === MenuListTypes.EDIT && (
                <div className={styles.cardActionBox}>
                    {
                        data.is_active
                            ?
                            <>
                                {actions.map((action, index) => (
                                    <div
                                        key={index}
                                        onClick={() => action.onClick(categoryId, data, title)}
                                        className={styles.actionIconBox}
                                    >
                                        <img src={action.icon} alt="icon" />
                                    </div>
                                ))}
                                {
                                    !mobileScreen
                                    &&
                                    <div
                                        className={styles.actionIconBox}
                                        onMouseDown={handleIconMouseDown}
                                        onMouseUp={handleIconMouseUp}
                                    >
                                        <img src={Drag} alt="icon" />
                                    </div>
                                }
                            </>
                            :
                            <div
                                className={styles.actionIconBox}
                                onClick={() => handleItemIsActive!(categoryId, data)}
                            >
                                <img src={View} alt="icon" />
                            </div>
                    }
                </div>
            )}
        </div>
    )
};

export default ItemCard
